<template>
  <div
    v-if="Object.values(gradesByCareer).length"
    class="col-12"
  >
    <p>
      Promedio en pruebas nacionales de los egresados en esta carrera en esta institución.
    </p>
    <ul class="list-unstyled">
      <div
        v-for="(value, name) in gradesByCareer"
        :key="value"
      >
        <li>
          {{ name }}
          <BaseProgress
            grade
            :value="Math.round(value*100)/100"
            :max="30"
          />
        </li>
      </div>
    </ul>
  </div>
  <div
    v-else
    class="col-12"
  >
    Sin datos
  </div>
</template>
<script>

export default {
    name: 'Pruebas',
    props: {
        gradesByCareer: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {};
    },
    mounted() {},
};
</script>
